import { useEffect } from "react"
import ErrorBoundary from "components/ErrorBoundary";
import ToastContainer from "components/ToastContainer";
import { PageContent } from "pages/PageContent/PageContent";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "routes";
import { store } from "slice";
import { ThemeProvider } from "styled-components";
import theme from "theme";
import ReactGA from "react-ga4";

ReactGA.initialize("G-LPJLYSB5CL")

const App = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: window.location.pathname,
        })
    }, []);

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <Router>
                    <ErrorBoundary>
                        <PageContent>
                            <ToastContainer position="top" />
                            <AppRoutes />
                        </PageContent>
                    </ErrorBoundary>
                </Router>
            </ThemeProvider>
        </Provider>
    );
};

export default App;
